import React, { ReactNode } from "react"
import { Navigate, useSearchParams } from "react-router-dom"
import { ROUTES } from "@constants"
import { Box } from "@mui/material"
import { useAppSelector } from "../store/store"
import AppBottomNavigation from "../components/app-bottom-navigation/app-bottom-navigation"

interface SecureLayoutProps {
  children?: ReactNode // Update the type to ReactNode
}

function SecureLayout({ children }: SecureLayoutProps) {
  const isLogin = useAppSelector((state) => state.login.loggedIn)
  const [searchParams] = useSearchParams()
  const uuid = searchParams.get("statement") as string

  if (!isLogin && uuid !== undefined && uuid !== "" && uuid !== null) {
    return (
      <Navigate
        to={ROUTES.LOGIN().concat("?statement=").concat(uuid)}
        replace
      />
    )
  }

  if (!isLogin) {
    return <Navigate to={ROUTES.LOGIN()} replace />
  }

  return (
    <Box display="flex" flexDirection="column">
      <Box
        component="main"
        style={{ position: "relative", bottom: "56px" }}
        flexGrow={1}
      >
        {children}
      </Box>

      <Box component="footer" width="100%">
        <AppBottomNavigation />
      </Box>
    </Box>
  )
}

SecureLayout.defaultProps = {
  children: null, // Provide default value for children
}

export default SecureLayout
